import { useMutation, useQueryClient } from '@tanstack/react-query';
import { AuthenticationContextType } from 'Foundation/Authentication';
import { PricingScenarioPaylod } from '../../components/HbtMasterPoolAddModifyPricingScenariosFlyout/types';

import {
  addPricingScenario,
  LockAndUnlockProps,
  lockAndUnlockScenario,
  modifyPricingScenario,
  patchOfferScenario
} from '../HbtMasterPoolLoansInventoryDetailService';

export const useAddPricingScenarioMutation = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async ({
      authenticationContext,
      payload
    }: {
      authenticationContext: AuthenticationContextType;
      payload: PricingScenarioPaylod;
    }) => {
      const response = await addPricingScenario({ authenticationContext, payload });
      return response;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['pricingScenario'] });
    },
    onError: (error) => {
      throw new Error(error.message ?? 'Error while adding pricing scenarios');
    }
  });
};

export const useModifyPricingScenarioMutation = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async ({
      authenticationContext,
      payload
    }: {
      authenticationContext: AuthenticationContextType;
      payload: PricingScenarioPaylod;
    }) => {
      const response = await modifyPricingScenario({ authenticationContext, payload });
      return response;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['pricingScenario'] });
    },
    onError: (error) => {
      throw new Error(error.message ?? 'Error while modifying pricing scenarios');
    }
  });
};

export const usePatchOfferScenario = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: patchOfferScenario,
    onError: () => {
      console.error('Error while adding pricing scenarios');
    },
    onSuccess: (data, variables) => {
      queryClient.invalidateQueries({
        queryKey: ['offer-scenarios', variables.masterPoolAccountNumber]
      });
    }
  });
};

export const useLockAndUnlockScenario = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (props: LockAndUnlockProps) => {
      return lockAndUnlockScenario(props);
    },
    onSuccess: (data, variables) => {
      queryClient.invalidateQueries({
        queryKey: ['lockandUnlock', variables.payload.masterPoolAccountNumber]
      });
    },
    onError: (error: any) => {
      console.error('Failed to lock/unlock scenario:', error);
    }
  });
};
